module.exports = __webpack_public_path__ + "media/cards/mastercard-b27a932a.png";